import {setInitialState} from '../../../utils/reducerOperations';

export const Default=()=>({
    driversToggle:'hide',
    fetchDriversDataApi:setInitialState(),
});